module.exports = __webpack_public_path__ + "img/barcelo-resort.245e990f.jpg";